import { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";

export const inr = (n) => {
  const v = Number(n || 0);
  if (v >= 1e7) return `₹${(v / 1e7).toFixed(v % 1e7 === 0 ? 0 : 2)} Cr`;
  if (v >= 1e5) return `₹${(v / 1e5).toFixed(v % 1e5 === 0 ? 0 : 1)} L`;
  return `₹${v.toLocaleString("en-IN")}`;
};
export const priceLabel = (p) => p.deal_type === "lease" ? `${inr(p.price_inr)}/month` : inr(p.price_inr);
export const DEAL_LABEL = { acquisition: "Acquisition", representation: "Representation", lease: "Lease" };
export const SUB_LABEL = { apartment: "Apartment", villa: "Villa", penthouse: "Penthouse", plot: "Plot", farmhouse: "Farmhouse", office: "Office", retail: "Retail", warehouse: "Warehouse", land: "Land", hospitality: "Hospitality", mixed_use: "Mixed Use" };
export const SUB_TYPES = { residential: ["apartment", "villa", "penthouse", "plot", "farmhouse"], commercial: ["office", "retail", "warehouse", "land", "hospitality", "mixed_use"] };
export const AMENITIES = ["Private Pool", "Concierge", "Sea View", "Garden", "Home Automation", "Club House", "Gym", "Power Backup", "EV Charging", "Security 24×7", "Parking", "Terrace", "Lift", "Fire Safety", "Loading Dock", "High Ceiling"];

const stroke = { fill: "none", stroke: "currentColor", strokeWidth: 1.4, strokeLinecap: "round", strokeLinejoin: "round" };
export const Icon = {
  Diamond: (p) => <svg viewBox="0 0 24 24" width={p.size || 14} height={p.size || 14} {...stroke} className={p.className}><path d="M6 3h12l4 6-10 12L2 9l4-6z" /><path d="M2 9h20M9 3l3 18M15 3l-3 18" /></svg>,
  Shield: (p) => <svg viewBox="0 0 24 24" width={p.size || 14} height={p.size || 14} {...stroke} className={p.className}><path d="M12 2l8 3v6c0 5-3.5 9-8 11-4.5-2-8-6-8-11V5l8-3z" /><path d="M8.5 12l2.5 2.5 4.5-5" /></svg>,
  Home: (p) => <svg viewBox="0 0 24 24" width={p.size || 14} height={p.size || 14} {...stroke} className={p.className}><path d="M3 11l9-7 9 7v9a1 1 0 01-1 1h-5v-6H9v6H4a1 1 0 01-1-1v-9z" /></svg>,
  Tower: (p) => <svg viewBox="0 0 24 24" width={p.size || 14} height={p.size || 14} {...stroke} className={p.className}><path d="M5 21V5l7-3 7 3v16M9 9h1M14 9h1M9 13h1M14 13h1M9 17h1M14 17h1M3 21h18" /></svg>,
  Area: (p) => <svg viewBox="0 0 24 24" width={p.size || 14} height={p.size || 14} {...stroke} className={p.className}><path d="M4 4h16v16H4zM4 9h5V4M15 20v-5h5" /></svg>,
  Pin: (p) => <svg viewBox="0 0 24 24" width={p.size || 14} height={p.size || 14} {...stroke} className={p.className}><path d="M12 22s7-7.5 7-13a7 7 0 10-14 0c0 5.5 7 13 7 13z" /><circle cx="12" cy="9" r="2.5" /></svg>,
  Key: (p) => <svg viewBox="0 0 24 24" width={p.size || 14} height={p.size || 14} {...stroke} className={p.className}><circle cx="8" cy="15" r="4" /><path d="M11 12l9-9M16 5l3 3M13 8l3 3" /></svg>,
  Handshake: (p) => <svg viewBox="0 0 24 24" width={p.size || 14} height={p.size || 14} {...stroke} className={p.className}><path d="M2 9l5-4 5 4M22 9l-5-4-5 4M7 5v9l5 5 5-5V5" /></svg>,
  Arrow: (p) => <svg viewBox="0 0 24 24" width={p.size || 14} height={p.size || 14} {...stroke} className={p.className}><path d="M5 12h14M13 6l6 6-6 6" /></svg>,
  Down: (p) => <svg viewBox="0 0 24 24" width={p.size || 14} height={p.size || 14} {...stroke} className={p.className}><path d="M12 5v14M6 13l6 6 6-6" /></svg>,
  Close: (p) => <svg viewBox="0 0 24 24" width={p.size || 14} height={p.size || 14} {...stroke} className={p.className}><path d="M6 6l12 12M18 6L6 18" /></svg>,
  Sliders: (p) => <svg viewBox="0 0 24 24" width={p.size || 14} height={p.size || 14} {...stroke} className={p.className}><path d="M4 7h10M18 7h2M4 17h4M12 17h8" /><circle cx="16" cy="7" r="2" /><circle cx="10" cy="17" r="2" /></svg>,
  Check: (p) => <svg viewBox="0 0 24 24" width={p.size || 14} height={p.size || 14} {...stroke} className={p.className}><path d="M5 12l5 5L20 7" /></svg>,
  Camera: (p) => <svg viewBox="0 0 24 24" width={p.size || 14} height={p.size || 14} {...stroke} className={p.className}><path d="M4 8h3l2-3h6l2 3h3v12H4z" /><circle cx="12" cy="13" r="3.5" /></svg>,
};

export function Monogram({ className = "" }) {
  return (
    <div className={`pd-placeholder w-full h-full flex items-center justify-center ${className}`} data-testid="pd-placeholder">
      <span className="pd-serif text-[#C9A84C]/80" style={{ fontSize: "min(18vw, 96px)", letterSpacing: "0.1em" }}>V</span>
    </div>
  );
}

export function Badge({ kind }) {
  if (kind === "rera") return <span className="pd-tag" data-testid="pd-badge-rera"><Icon.Shield size={12} /> RERA Verified</span>;
  if (kind === "curated") return <span className="pd-tag" data-testid="pd-badge-curated"><Icon.Diamond size={12} /> Vinci Curated</span>;
  return null;
}

export function GoldButton({ children, solid, className = "", testId, ...rest }) {
  return <button data-testid={testId} className={`pd-cta ${solid ? "pd-cta-solid" : ""} ${className}`} {...rest}>{children}</button>;
}

export function Skeleton({ portrait }) {
  return (
    <div className="pd-surface border pd-line" data-testid="pd-skeleton">
      <div className={`pd-skeleton ${portrait ? "aspect-[3/4]" : "aspect-[16/10]"}`} />
      <div className="p-6 space-y-3"><div className="pd-skeleton h-3 w-1/3" /><div className="pd-skeleton h-6 w-3/4" /><div className="pd-skeleton h-3 w-1/2" /></div>
    </div>
  );
}

export function CountUp({ to, duration = 1600 }) {
  const [v, setV] = useState(0);
  const ref = useRef(null);
  const started = useRef(false);
  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const io = new IntersectionObserver(([e]) => {
      if (!e.isIntersecting || started.current) return;
      started.current = true;
      const t0 = performance.now();
      const tick = (t) => { const p = Math.min(1, (t - t0) / duration); setV(Math.round((1 - Math.pow(1 - p, 3)) * to)); if (p < 1) requestAnimationFrame(tick); };
      requestAnimationFrame(tick);
    }, { threshold: 0.4 });
    io.observe(el);
    return () => io.disconnect();
  }, [to, duration]);
  useEffect(() => { if (started.current) setV(to); }, [to]);
  return <span ref={ref}>{v.toLocaleString("en-IN")}</span>;
}

export function PropertyCard({ p, wide }) {
  const landscape = wide || p.property_type === "commercial";
  const photo = p.photos?.[0]?.url;
  return (
    <Link to={`/property-desk/p/${p.slug}`} className="pd-card block group" data-testid={`pd-card-${p.id}`}>
      <div className={`pd-img-wrap ${landscape ? "aspect-[16/10]" : "aspect-[3/4]"}`}>
        {photo ? <img src={photo} alt={p.title} loading="lazy" /> : <Monogram />}
        <div className="absolute top-4 left-4 flex gap-2">{p.rera_verified && <Badge kind="rera" />}</div>
        {p.curated && <div className="absolute top-4 right-4"><Badge kind="curated" /></div>}
        <div className="pd-card-cta" data-testid={`pd-card-cta-${p.id}`}>View Property <Icon.Arrow size={13} /></div>
      </div>
      <div className="p-6 md:p-7">
        <div className="pd-label mb-3">{p.city}{p.locality ? ` · ${p.locality}` : ""}</div>
        <h3 className="pd-serif text-2xl md:text-[28px] leading-tight tracking-wide text-[#F5F5F0]">{p.title}</h3>
        <div className="mt-4 flex items-center justify-between gap-4">
          <span className="pd-tag !py-1 !px-2.5">{DEAL_LABEL[p.deal_type]} · {SUB_LABEL[p.sub_type] || p.sub_type}</span>
          <span className="pd-card-price pd-serif text-xl pd-gold">{priceLabel(p)}</span>
        </div>
      </div>
    </Link>
  );
}

export function EmptyState({ text }) {
  return (
    <div className="border pd-line pd-surface px-8 py-20 text-center" data-testid="pd-empty-state">
      <Icon.Diamond size={28} className="mx-auto text-[#C9A84C]/70 mb-6" />
      <p className="pd-serif text-2xl md:text-3xl text-[#F5F5F0]/90 max-w-2xl mx-auto leading-relaxed">{text}</p>
    </div>
  );
}

export function SectionHead({ label, title, children }) {
  return (
    <div className="flex items-end justify-between gap-6 flex-wrap mb-14">
      <div><div className="pd-label mb-4">{label}</div>{title && <h2 className="pd-serif text-4xl md:text-5xl tracking-wide">{title}</h2>}</div>
      {children}
    </div>
  );
}
